import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';
import Provisioning from 'pages/views/ecom/provisioning';

const paths = {
  provisioning: '/ecom/provisioning',
};

export default [
  <RouteIfRights
    path={paths.provisioning}
    key={paths.provisioning}
    component={Provisioning}
    rights="ecom"
  />,
];

export { paths };
